import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'filterMember'
})
export class FilterMemberSearchPipe implements PipeTransform {
  transform(items: any[], searchtext: string): any[] {
    if (!items) return [];
    if (!searchtext) return items;
    searchtext = searchtext.toLowerCase();
    return items.filter(it => {
      console.log('it ', it);
      if (it.userName !== null)
        return it.userName.toLowerCase().includes(searchtext);
    });
  }
}
